import { icon } from "@fortawesome/fontawesome-svg-core/import.macro"
import VendorDetailsContainer from "@legacy/vendors/VendorDetailsContainer"

import useHasAccess from "@hooks/useHasAccess"
import useIsDesktop from "@hooks/useIsDesktop"
import useSlugExtractor from "@hooks/useSlugExtractor"
import useToastQueue from "@hooks/useToastQueue"

import { TopBar } from "@organisms"

import { AppFrame } from "@templates"

import { VENDOR_ROUTES } from "@routes/vendor"

import { PERMISSION_LEVEL } from "@constants/permissionLevel"

export default function vendorDetails() {
    const isDesktop = useIsDesktop()

    const [listRoute] = useSlugExtractor([VENDOR_ROUTES.LIST])
    const { addToastToQueue } = useToastQueue()
    const { hasPermission } = useHasAccess()

    const backDestination = hasPermission("vendors_list_permission", PERMISSION_LEVEL.FULL) ? listRoute : undefined

    return (
        <AppFrame.Root pageId="VendorDetails">
            <TopBar.Root>
                <TopBar.Header>
                    <TopBar.TopBarHeaderStart>
                        <TopBar.PageTitle
                            label="Vendors"
                            icon={icon({ name: "store", style: "regular", family: "sharp" })}
                            iconActive={icon({ name: "store", style: "solid", family: "sharp" })}
                            destination={backDestination}
                            iconOnly={!isDesktop}
                        />
                        <TopBar.VerticalDivider />
                        <TopBar.PageSubtitle label="Vendor Details" backDestination={backDestination} />
                    </TopBar.TopBarHeaderStart>
                </TopBar.Header>
            </TopBar.Root>
            <AppFrame.PageContent>
                <VendorDetailsContainer addToastToQueue={addToastToQueue} />
            </AppFrame.PageContent>
        </AppFrame.Root>
    )
}
